import type { Dispatch } from 'react';
import { WhatsAppSection } from '../tenant-sections/WhatsAppSection';
import type { WizardAction, WizardDraft } from './types';

/** Paso 3 del wizard = la sección WhatsApp montada en modo wizard. */
export function Step3WhatsAppChannel({
  draft,
  dispatch,
}: {
  draft: WizardDraft;
  dispatch: Dispatch<WizardAction>;
}) {
  return (
    <WhatsAppSection
      mode="wizard"
      testId="wizard-step-3"
      tenantId={draft?.tenantId ?? ''}
      value={draft?.channels?.whatsapp ?? {}}
      onSaved={(patch) => {
        const p = patch as {
          secretsUploaded?: boolean;
          phoneNumberId?: string;
          webhookRegistered?: boolean;
        };
        if (p.secretsUploaded) {
          dispatch({ type: 'mark-whatsapp-secrets', phoneNumberId: p.phoneNumberId ?? '' });
        }
        if (p.webhookRegistered) dispatch({ type: 'mark-whatsapp-webhook' });
      }}
      onContinue={() => dispatch({ type: 'goto', step: 4 })}
    />
  );
}
